import React from "react";
import "./ReelSection.css";
import firstImage from "../../assets/img/reel-section/first_reel.png";
import firstImage2 from "../../assets/img/reel-section/first_reel2.png";
import { Countdown } from "../countdown/Countdown";

export const ReelSection = () => {
  return (
    <div className="reel-container">
      <div className="reel-content">
        <div>
          <div className="name-first-wrapper">
            <span className="name-first">Fernanda</span>
          </div>
          <div className="name-second-wrapper">
            <span className="name-second">
              <span className="ampersand">&amp;</span>
              Fabián
            </span>
          </div>
        </div>

        {/* <img src={firstImage2} alt="f&f" /> */}
        <div>
          <Countdown />
        </div>
      </div>
    </div>
  );
};
